import classes from './ReceiptsView.scss';
import React, { Component } from 'react';
import { fromJS } from 'immutable';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import { Col, Row } from 'react-flexbox-grid/lib/index';
import moment from 'moment';

class StocktakingReceiptView extends Component {
    formatDateWithTime(date) {
        if (!date) {
            return '';
        }
        return moment(date).format('DD.MM.YYYY');
    }

    render = () => {
        const itemNodes = this.props.receipt.getIn(['stocktaking_items'], fromJS([])).map(item => {
            return (
                <TableRow selectable={false} adjustForCheckbox={false} key={item.get('id')}>
                    <TableRowColumn>{item.get('ean')}</TableRowColumn>
                    <TableRowColumn>{item.get('item_name')}</TableRowColumn>
                    <TableRowColumn>{item.get('amount')}</TableRowColumn>
                </TableRow>
            );
        });

        return (
            <div>
                <Row className={classes.headline}>
                    <Col className={classes.column} xs={3}>
                        <strong>Menge</strong>
                        <br />
                        {this.props.receipt.get('amount')}
                    </Col>
                    <Col className={classes.column} xs={3}>
                        <strong>Filiale</strong>
                        <br />
                        {this.props.receipt.get('branch')}
                    </Col>
                    <Col className={classes.column} xs={3}>
                        <strong>Erfasser</strong>
                        <br />
                        {this.props.receipt.get('user')}
                    </Col>
                    <Col className={classes.column} xs={3}>
                        <strong>Datum</strong>
                        <br />
                        {this.formatDateWithTime(this.props.receipt.get('date'))}
                    </Col>
                    <Col className={classes.column} xs={3}>
                        <strong>Lager</strong>
                        <br />
                        {this.props.receipt.get('warehouse_number')}
                    </Col>
                    <Col className={classes.column} xs={3}>
                        <strong>Sollmenge</strong>
                        <br />
                        {this.props.receipt.get('target_amount')}
                    </Col>
                </Row>
                <Table multiSelectable={false} selectable={false}>
                    <TableHeader
                        adjustForCheckbox={true}
                        selectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}>
                        <TableRow>
                            <TableHeaderColumn>EAN</TableHeaderColumn>
                            <TableHeaderColumn>Name</TableHeaderColumn>
                            <TableHeaderColumn>Menge</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody>{itemNodes}</TableBody>
                </Table>
            </div>
        );
    };
}

export default StocktakingReceiptView;
